import React from "react";
import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function Report() {
  return <Skeleton className={styles.report} />;
}

export { Report };
